export { default } from "./Pill";
